import $ from 'jquery'
import cfg from './config'
import _def from './default'
import util from 'util'
import _ from 'lodash'
import validator from './validator'

global.config = global.config || $.extend({"apidomain":process.env.API_URL},cfg)
if(process.env.NODE_ENV !== "production"){
	global.config.version = cfg.version + " (test)" + process.env.COMPILE_DATE
	global.config.debug = true
}else{

}

console.info(util.format("Version.%s - Compile:%s", cfg.version, process.env.COMPILE_DATE))

let _this = {
	loadCounter:0,
	config:global.config,
	getApiUrl(method,ext){
		let extStr = (ext || "").toString()
		if($.isPlainObject(ext)){
			extStr = $.param(ext)
		}
		//$.ajaxSetup(_this.ajaxCfg)
		//return util.format("%s/%s",global.config.apidomain, method)
		return util.format("%s/%s?_var=%s&%s",global.config.apidomain, method, cfg.version, extStr)
	},
	ajaxCfg: {
		crossDomain: true,
		xhrFields: {"withCredentials": true},
		beforeSend(){_this.loading(true)},
		timeout: 20*1000,
		complete(){_this.loading()}
	},
	getAjaxData(vm,url,data,title){
	   return new Promise((resolve,reject)=>{
		   $.post(url,data).then((json)=>{
			   let status;
			   if(!json.status)json=JSON.parse(json);
			   status=parseInt(json.status);
			   if(status!==200){
				   switch(status){
					   default:if(_this.checkAjaxStatus(vm,json,title))break;
					   else reject(json.msg);
				   }
			   }else{
				   resolve(json.data)
			   }
		   })
	   })
	   
	},
	isNull(val){
		return "" === val || null === val || undefined === val || ("number" !== typeof(val)?$.isEmptyObject(val) : false)
	},
	isEmptyObject(obj,arr){
		let empty = true;
		if(arr){
			$.each(arr,(k,v) => {
				if(!_this.isNull(obj[v])){
					empty = false
					return false
				}
			})
		}else{
			$.each(obj, (k,v) => {
				if(!_this.isNull(v)){
					empty = false
					return false
				}
			})
		}
		return empty
	},
	clone(data){
		if($.isArray(data))
		{
			let arr = data.map((o) => {
				return $.isPlainObject(o)? _this.clone(o) : o
			})
			return arr
		} else {
			let obj=new Object();
			for(let key in data){
				if($.isArray(data[key])||$.isPlainObject(data[key])){
                    obj[key] = _this.clone(data[key])
				}else{
					obj[key] = data[key]
				}
			}		
			return obj;	
			// return $.extend({},data);
		}
	},
	
	cleanProp(data,arr){let temp = _this.clone(data);arr.forEach((item) => { delete temp[item] });return temp},
	removeEmptyValue(d,c){
		$.each(c,(k,v) => {
			if(d[k] === v) d[k] = null
		})
		return d
	},
	getMoney(val){
		val = val.toString()
		if(val.indexOf(",") != -1){
			let arr = val.split(","), str = arr.join("")
			return parseFloat(str)
		}else{
			return parseFloat(val)
		}
		
	},
	loading(b){
		if(b){
			$("#loading").attr("class","animated slideInDown")
			_this.loadCounter++
		}else{
			$("#loading").attr("class","animated slideOutUp")
				.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",function(){
					if(--_this.loadCounter < 1) $(this).attr("class","hidden")
				})
		}
	},
	getBankFixed(val, len){
		if(undefined === len) len = 2;
		let old = val,
			pow = Math.pow(10,len),
			a1 = pow * old;
		a1 = Math.round(a1)
		let oldstr = old.toString(),
			start = oldstr.indexOf("."),
			partstr = oldstr.split(".");
		if(start > 0 && partstr[1].length > len) {
			if(oldstr.substr(start + len + 1, 1) == 5) {
				let flag = oldstr.substr(start + len, 1) - 0;
				if(partstr[1].length > len+1){
					//进位所以不操作
				}
				else if(flag % 2 == 0) {
					a1 -= 1;
				}
			}
		}
		return (a1 / pow);
	},
	getIDCardInfo(num){
    	let birthday,sex, y, m, d
    	if(num.length === 15){
    		y = "19"+num.substr(6,2)
    		m = num.substr(8,2)
    		d = num.substr(10,2)
			
			sex = parseInt(num.substr(-1))%2?1:2
		}else if(num.length === 18)
		{
			y = num.substr(6,4)
    		m = num.substr(10,2)
    		d = num.substr(12,2)
			sex = parseInt(num.substr(-2,1))%2?1:2
		}else{
			return false
		}
		birthday = new Date(y, parseInt(m)-1, d)
		return {birthday,sex}
    },
	getStoredApiProp(key){
		// console.log(_this.getApiUrl(key)+'00000')
		let func = (callback,reject) => {
			let val = _this.getStoredProp(key)
			if(!!val){
				callback(val)
				return;
			}else{
				let u = _this.getApiUrl(key)
				// console.log(u+'11111111111111')
	            $.get(u,(json) => {
	                let status = parseInt(json.status)
	                if(200 !== status){
	                  	reject(json)
	                    return;
	                }else{
	                	val = json.data
	                	_this.setStoredProp(key,val)
	                  	callback(val)
	                }
	            },"JSON")
			}
		}
		return new Promise(func)
	},
	removeStoredProp(key){
		if(key){
			delete window.xwStored[key]
		}else{
			delete window.xwStored
		}
	},
	getStoredProp(key){
		if(!window.xwStored) return undefined
		if(_this.isNull(window.xwStored[key])){
			return undefined;
		}else{
			return _this.clone(window.xwStored[key])
		}
		
	},
	setStoredProp(key,val){
		if(!window.xwStored) window.xwStored = {};
		if($.isPlainObject(key)){
			$.extend(window.xwStored, _this.clone(key))
		}else{
			window.xwStored[key] = _this.clone(val)
		}
	},
	promiseErrorChecker(vm, json, title){
		title = title || "错误提示";
		if(json instanceof Error){
			vm.$alert(json.message, title, {
				confirmButtonText: "刷新",
				callback(){location.reload(true)}
			})
		}else {
			let status = parseInt(json.status);
			switch(status){
				default:
					if(_this.checkAjaxStatus(vm,json,title)) break;
					else{
						vm.$alert(json.msg,{
	  						confirmButtonText: "刷新",
	  						callback(){location.reload(true)}
	  					})
					}
					break;
			}
		}
	},
	Storage(key,value){
      if(arguments.length==1){
		  return JSON.parse(sessionStorage[key])
	  }else if(arguments.length==2){
           sessionStorage[key]=JSON.stringify(value)
	  }
	},
	checkAjaxStatus(vm,json,title){
		title = title || "错误提示";
		let status = parseInt(json.status);
		switch(status){
			case 500:
			
				vm.$alert(json.msg,"请抓图并提交给相关人员处理！",{
					confirmButtonText: "刷新",
					callback(){location.reload(true)}
				})
				return true
			case 1000:
				vm.$emit("loading",false)
				vm.$alert("抱歉！您没有权限请求或提交此数据。",title,{
					confirmButtonText: "刷新",
					callback(){location.reload(true)}
				})
				return true
			case 1001:
				vm.$bus.emit("loading",false)
				vm.$bus.emit("needLogin",false)
				//global.$bus.emit("needLogin")
				return true;
		}
		return false;
	},
	setTitle(str){
		document.title = util.format("%s - %s",str, global.title)
      	$("body").trigger("resize")
	},
	checkPermission(name,any){
		if($.isArray(name)){
			let counter = 0;
			$.each(name,function(){
				if($.inArray(name,global.user.apiPermission) > -1) counter++;
			})
			if(any && counter > 0) return true
			return (counter === name.length)
		}
		else return $.inArray(name,global.user.apiPermission) > -1;
	},
	date(fmt,da){
		let d = (da instanceof Date)? da : (da === undefined ? new Date():new Date(da));
		if(d.getFullYear().toString() === "NaN" ){
			da = da.replace(/-/g,"/");
			d = new Date(da);
		}
		if(!fmt) return d;
		let o = {
	        "M+": d.getMonth() + 1, //月份 
	        "d+": d.getDate(), //日 
	        "h+": d.getHours(), //小时 
	        "m+": d.getMinutes(), //分 
	        "s+": d.getSeconds(), //秒 
	        "q+": Math.floor((d.getMonth() + 3) / 3), //季度 
	        "S": d.getMilliseconds() //毫秒 
	    };
	    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
	    for (let k in o)
	    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	    return fmt;
	},
	// 获取年化利率
	// * @param  number   $rate     月利率
	// * @param  integer  $period   期数
	// * @param  integer  $precise  循环精度
	// * @param  integer  $step     最高年化可能是100%的几倍
	// * @return number   返回年化利率，保留10位小数
	getYearRate($rate, $period, $step = 1, $precise = 1000000000000){
		console.log($rate, $period);
		// 百分比转化为实际小数点
		// $rate=$rate/100;
		let $left = $rate + 1 / $period;
		let $prev = 0;
		let $curr = 0;
		let $middle = 0;
		let $start = $rate * $precise;
		let $end   = $step * $precise;
		
		    // 二分法查找对应的利率
			while ($start <= $end) {
				$middle = ($start + $end) / 2;
				let $x = $middle / $precise;
				$curr = $x + $x / (Math.pow(1 + $x, $period) - 1);
				if ($left < $curr) {
					$end = $middle - 1;
				} else if ($left > $curr) {
					$start = $middle + 1;
				} else {
					return ($middle * 12 / $precise).toFixed(10)
				}
			}
		
			return ($middle * 12 / $precise).toFixed(10)

	},
	// 获取月利率 年利率/12
	getMonthRate(yearRate){
		return yearRate/12
	},
	// * @param  number  $debt      欠款额度
	// * @param  number  $monthRate 月利率
	// * @param  integer $period    期数
	// * @param  integer $month     第几期
	// * @return number  当期应还本金
	getMonthPrincipal($debt, $monthRate, $period, $month){
		let $capital = $debt * $monthRate * Math.pow(1 + $monthRate, $month - 1) / (Math.pow(1 + $monthRate, $period) - 1);
		
		return this.getBankFixed($capital, 5);
	},
	// * @param  number  $debt      欠款额度
	// * @param  number  $monthRate 月利率
	// * @param  integer $period    期数
	// * @param  integer $month     第几期
	// * @return number  当期应还利息
	getMonthInterest($debt, $monthRate, $period, $month)
	{
		let $interest = $debt * $monthRate * (Math.pow(1 + $monthRate, $period) - Math.pow(1 + $monthRate, $month - 1)) / (Math.pow(1 + $monthRate, $period) - 1);
	
		return this.getBankFixed($interest, 5);
	},
	    /**
    //  * 获取首期待还本金
    //  * @param  [type] $argument [description]
    //  * @return [type]           [description]
    //  */
    getCurrentPrincipal($argument) 
    {
		console.log($argument);
        let $actual = this.getYearRate($argument['_interest_rate'] / 100, $argument['_period']);
		console.log($actual);
        return this.getBankFixed(this.getMonthPrincipal($argument['_loan'], $actual / 12, $argument['_period'], 1));
	},
	// * 获取首期待还本金
	// * @param  [type] $argument [description]
	// * @return [type]           [description]
	// */
   getCurrentInterest($argument) 
   {
	   let  $actual = this.getYearRate($argument['_interest_rate'] / 100, $argument['_period']);

	   return this.getBankFixed(this.getMonthInterest($argument['_loan'], $actual / 12, $argument['_period'], 1));
   }



}

_this.setStoredProp(_def)

window.xwCommon = $.extend(_this,{validator})

export default _this


// WEBPACK FOOTER //
// ./src/lib/util/index.js